<template lang="pug">
  .flicking-wrapper
    flicking(
      v-bind="extendAttrs"
      v-on="extendListeners"
    )
      slot

    .flicking-arrows-container.px-3
      .flicking-arrows-line
        v-btn.flicking-arrows(
          absolute left
          fab depressed small
          color="#00000070" :dark="!moved"
          :disabled="moved"
          v-show="arrows.left.value"
          @click="arrows.left.prev"
        )
          v-icon() mdi-chevron-left

        v-btn.flicking-arrows(
          absolute right
          fab depressed small
          color="#00000070" :dark="!moved"
          :disabled="moved"
          v-show="arrows.right.value"
          @click="arrows.right.next"
        )
          v-icon() mdi-chevron-right
</template>

<script>
import { Flicking } from '@egjs/vue-flicking';

const CONTEXT_NAME = 'flicking';

export default {
  components: {
    Flicking,
  },
  props: {
    disappear: {
      type: Boolean,
      default: false,
    },
    disappearPosition: {
      type: String,
      default: 'right',
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      flickingInstance: null,
      moved: false,
      arrows: {
        left: {
          value: false,
          prev: () => null,
        },
        right: {
          value: false,
          next: () => null,
        },
      },
    };
  },
  computed: {
    disappearClasses() {
      const { disappear, disappearPosition } = this;
      return {
        [`${CONTEXT_NAME}-disappear`]: disappear,
        [`${CONTEXT_NAME}-disappear-position-${disappearPosition}`]: disappear,
      };
    },
    extendAttrs() {
      const { $attrs, disappearClasses } = this;
      return {
        options: {
          ...$attrs.options,
        },
        class: {
          ...disappearClasses,
        },
      };
    },
    extendListeners() {
      const { $listeners } = this;
      return {
        ...$listeners,
        ready: (data) => {
          const { currentTarget } = data;
          this.initArrowsMethods(currentTarget);
          this.updateArrowsValues(currentTarget);
        },
        move: (data) => {
          const { currentTarget } = data;
          this.moved = true;
          this.updateArrowsValues(currentTarget);
        },
        'move-end': () => {
          this.moved = false;
        },
        'after-resize': (data) => {
          const { currentTarget } = data;
          this.updateArrowsValues(currentTarget);
        },
      };
    },
  },
  methods: {
    initArrowsMethods(val) {
      this.arrows.left.prev = () => val.prev(300);
      this.arrows.right.next = () => val.next(300);
    },
    updateArrowsValues(val) {
      const { visiblePanels, panels } = val;
      const [firstPanel] = panels;
      const [firstVisiblePanel] = visiblePanels;
      const lastPanel = panels.at(-1);
      const lastVisiblePanel = visiblePanels.at(-1);

      this.arrows.right.value = (lastVisiblePanel.index !== lastPanel.index);
      this.arrows.left.value = (firstVisiblePanel.index !== firstPanel.index);
    },
  },
};
</script>

<style lang="scss" scoped>
  .flicking {
    &-wrapper {
      position: relative;
    }

    &-disappear {
      &:after {
        content: "";
        z-index: 1;
        position: absolute;
        top: 0;
        width: 25%;
        height: 100%;
        background: linear-gradient(-90deg, rgba(255,255,255, 1), rgba(255,255,255, 0));
      }

      &-position-right {
        &:after {
          right: 0,
        }
      }
    }

    &-arrows {
      pointer-events: all;
      transform: translateY(-50%);

      &-line {
        display: flex;
      }

      &-container {
        z-index: 1;
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        justify-content: center;
      }
    }
  }
</style>
